import { useEffect, useRef } from "react";


/**
 * Internal keycode to external keycode
 */
var keyDict= {
    "ArrowUp":38,
    "ArrowDown":40,
    "ArrowLeft":37,
    "ArrowRight":39,
    "Enter":13,
    "10":48,
    "1":49,
    "2":50,
    "3":51,
    "4":52,
    "5":53,
    "6":54,
    "7":55,
    "8":56,
    "9":57
};

/**
 * Custom Hook that takes in an map of key string to callback function.
 * This allows an component to detect 'message' event.
 *
 * eg. { '1': () => select(1), 'ArrowRight': () => navigateToNextPage() }
 * @param keyMap {{}}
 */
export function useKeyMap(keyMap) {
    let translatedKeyMap = {};
    for (const key in keyMap) {
        translatedKeyMap[keyDict[key]] = keyMap[key];
    }

    const keyMapRef = useRef(translatedKeyMap);
    keyMapRef.current = translatedKeyMap;

    useEffect(() => {
        const handleInjectKeyMessage = (e) => {
            if (e.data.command === 'injectKey') {
                if (keyMapRef.current.hasOwnProperty(e.data.keyCode)) {
                    keyMapRef.current[e.data.keyCode]();
                }
            }
        };
        window.addEventListener("message", handleInjectKeyMessage);
        // We need to do this to clean up the listener after component is unmounted
        return () => window.removeEventListener("message", handleInjectKeyMessage);
    }, [])
}

export function goToPCareMenu() {
    parent.postMessage({command: 'injectPcareKey', systemKeySource: 'PS', systemKey: 'MENU'}, '*');
}
